import { memo, useEffect } from "react";
import { useRouter } from "@/application/stores/routerStore";
import { isAuthenticated, saveToken } from "@/infrastructure/auth/authService";
import { useSessionStore } from "@/application/stores/sessionStore";
import { LandingPage } from "@/features/landing/LandingPage";
import { LoginPage } from "@/features/login/LoginPage";
import { ForgotPasswordPage } from "@/features/login/ForgotPasswordPage";
import { PlatformPage } from "@/features/platform/PlatformPage";
import { DocsPage } from "@/features/docs/DocsPage";
import "./index.css";

function handleIncomingToken() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  if (token) {
    saveToken(token);
    useSessionStore.getState().setFromToken(token);
    window.history.replaceState({}, "", window.location.pathname + "#platform");
    return true;
  }
  return false;
}

const hadIncomingToken = handleIncomingToken();

export const App = memo(function App() {
  const { route, navigate } = useRouter();

  useEffect(() => {
    if (hadIncomingToken) {
      navigate("platform");
      return;
    }
    if (route === "login" && isAuthenticated()) {
      navigate("platform");
    }
    if (route === "platform" && !isAuthenticated()) {
      navigate("login");
    }
  }, [route, navigate]);

  const effectiveRoute = route === "platform" && !isAuthenticated() ? "login" : route;

  const ROUTES = {
    landing: LandingPage,
    login: LoginPage,
    "forgot-password": ForgotPasswordPage,
    platform: PlatformPage,
    docs: DocsPage,
  } as const;

  const Page = ROUTES[effectiveRoute];
  return <Page />;
});

export default App;
